import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { useApp } from './state/store.ts';
import { Layout } from './components/Layout.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { LinkPage } from './pages/LinkPage.tsx';
import { BoardPage } from './pages/BoardPage.tsx';
import { CardPage } from './pages/CardPage.tsx';
import { MyTasksPage } from './pages/MyTasksPage.tsx';
import { TodayPage } from './pages/TodayPage.tsx';
import { ReportsPage } from './pages/ReportsPage.tsx';
import { SearchPage } from './pages/SearchPage.tsx';

function Splash({ text = 'Cargando…' }: { text?: string }) {
  return (
    <main className="auth">
      <p className="muted">{text}</p>
    </main>
  );
}

/** Requiere sesión y vínculo con Notion; sin vínculo no se usa la app. */
function Protected({ children }: { children: ReactNode }) {
  const { ready, userId, profile, online } = useApp();
  if (!ready) return <Splash />;
  if (!userId) return <Navigate to="/login" replace />;
  if (!profile)
    return <Splash text={online ? 'Cargando tu perfil…' : 'Sin conexión y sin datos guardados.'} />;
  if (!profile.notion_user_id) return <Navigate to="/vincular" replace />;
  return <Layout>{children}</Layout>;
}

export function App() {
  const { ready, userId, profile } = useApp();
  return (
    <Routes>
      <Route
        path="/login"
        element={!ready ? <Splash /> : userId ? <Navigate to="/" replace /> : <LoginPage />}
      />
      <Route
        path="/vincular"
        element={
          !ready ? (
            <Splash />
          ) : !userId ? (
            <Navigate to="/login" replace />
          ) : profile?.notion_user_id ? (
            <Navigate to="/" replace />
          ) : profile ? (
            <LinkPage />
          ) : (
            <Splash text="Cargando tu perfil…" />
          )
        }
      />
      <Route
        path="/"
        element={
          <Protected>
            <MyTasksPage />
          </Protected>
        }
      />
      <Route
        path="/hoy"
        element={
          <Protected>
            <TodayPage />
          </Protected>
        }
      />
      <Route
        path="/todas"
        element={
          <Protected>
            <BoardPage />
          </Protected>
        }
      />
      <Route
        path="/tarjeta/:id"
        element={
          <Protected>
            <CardPage />
          </Protected>
        }
      />
      <Route
        path="/reportes"
        element={
          <Protected>
            <ReportsPage />
          </Protected>
        }
      />
      <Route
        path="/buscar"
        element={
          <Protected>
            <SearchPage />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
